/**
 * Tipos del dominio de Time Cap.
 * Espejo del esquema en supabase/migrations/0001_schema.sql.
 */
/** Niveles de resultado. Menor siempre es mejor. */
export const StatusTier = {
    FINISHED: 0,
    CAPPED: 1,
    PENDING: 7,
    DNF: 8,
    DNS: 9,
};
//# sourceMappingURL=types.js.map